








//import { Action, ActionType, ClientEvent } from 'jovo-client-web-vue';
import { Component, Vue } from 'vue-property-decorator';

export default class App extends Vue {

  mounted() {
    console.log('mounted');
  }
}
